import { greenlightRegistrationLookup } from '../../../../../api/historyCheck';
import { formatAuthorizationHeader } from '../../../../../helpers/auth';
import { useMutation } from '@tanstack/react-query';
import { PAGE } from '../../../../../helpers/pages';

export const useGreenlightRegistrationLookup = () => {
  return useMutation({
    mutationKey: ['greenlight-registration-lookup'],
    mutationFn: (options: { registration: string; accessToken?: string }) =>
      greenlightRegistrationLookup(
        options.registration,
        formatAuthorizationHeader(options.accessToken),
      ),
    meta: { tags: [PAGE.HUB] },
  });
};
